import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Methodology from '../views/Methodology.vue'
import Personnel from '../views/Personnel.vue'
import Nation from '../views/Nation.vue'
import State from '../views/State.vue'
import County from '../views/County.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Nation',
    component: Nation,
    meta: {
      title: 'IEM COVID-19 Vaccination Modeling',
      metaTags: [
        {
          name: 'description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        },
        {
          property: 'og:description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        }
      ]
    }
  },
  {
    path: '/methodology',
    name: 'Methodology',
    component: Methodology,
    meta: {
      title: 'IEM COVID-19 Vaccination Modeling',
      metaTags: [
        {
          name: 'description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        },
        {
          property: 'og:description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        }
      ]
    }
  },
  {
    path: '/personnel',
    name: 'Personnel',
    component: Personnel,
    meta: {
      title: 'IEM COVID-19 Vaccination Modeling',
      metaTags: [
        {
          name: 'description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        },
        {
          property: 'og:description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        }
      ]
    }
  },
   {
    path: '/personnel/:option',
    name: 'Personnel',
    component: Personnel,
    meta: {
      title: 'IEM COVID-19 Vaccination Modeling',
      metaTags: [
        {
          name: 'description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        },
        {
          property: 'og:description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        }
      ]
    }
  },
  {
    path: '/nation',
    name: 'Nation',
    component: Nation,
    meta: {
      title: 'National Overview - IEM COVID-19 Vaccination Modeling',
      metaTags: [
        {
          name: 'description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        },
        {
          property: 'og:description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        }
      ]
    }
  },
  {
    path: '/state',
    name: 'State',
    component: State,
    meta: {
      title: 'IEM COVID-19 Vaccination Modeling',
      metaTags: [
        {
          name: 'description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        },
        {
          property: 'og:description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        }
      ]
    }
  },
  {
    path: '/state/:abbrev',
    name: 'State',
    component: State,
    meta: {
      title: 'IEM COVID-19 Vaccination Modeling',
      metaTags: [
        {
          name: 'description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        },
        {
          property: 'og:description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        }
      ]
    }
  },
  {
    path: '/county',
    name: 'County',
    component: County,
    meta: {
      title: 'IEM COVID-19 Vaccination Modeling ',
      metaTags: [
        {
          name: 'description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        },
        {
          property: 'og:description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        }
      ]
    }
  },
  {
    path: '/county/:url/',
    name: 'County',
    component: County,
    meta: {
      title: 'IEM COVID-19 Vaccination Modeling',
      metaTags: [
        {
          name: 'description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        },
        {
          property: 'og:description',
          content: "IEM's COVID-19 Vaccination Modeling dashboard estimates the potential benefits of administering the vaccine at the national, state, and county levels."
        }
      ]
    }
  },
  // {
  //   path: '/county/:state/:countyName',
  //   name: 'County',
  //   component: County,
  //   meta: {
  //     title: 'IEM COVID-19 Vaccination Modeling'
  //   }
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
